import { Component, ViewChild } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  ModalController,
  AlertController,
  NavController,
  NavParams,
  SelectPopover,
} from "ionic-angular";
import { ModalsEngineselectorPage} from "../modals-engineselector/modals-engineselector";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { RestProvider } from "../../providers/rest/rest";
import { DataProvider } from "../../providers/data/data";
import { ViewerPage } from "../viewer/viewer";
import * as fs from 'fs';
import * as Axios from "axios";
import { FileWriter } from "@ionic-native/file";
import { catchError, retry, first } from 'rxjs/operators';
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { notImplemented } from "@angular/core/src/render3/util";
import { saveAs } from 'file-saver';
import { FORGECLIENT } from '../../environments/environment';

@IonicPage()
@Component({
  selector: "page-upload",
  templateUrl: "upload.html",
})
export class UploadPage {
  @ViewChild("fileInput") fileInput;
  uploadForm = new FormGroup({
    uploadControl: new FormControl(),
  });
  reader = new FileReader();
  fileContent;
  fileToUpload: File = null;
  error;
  checkFile = false;
  bucketList = [];
  arrayofId = [];
  bucketKey;
  bucketId;
  role = parseInt(localStorage.getItem('role'));
  urnList = [];
  loading;
  activity_name = 'UpdateRVTParam';
  activityList = [];
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    private rest: RestProvider,
    public http: HttpClient,
    public modalController: ModalController,
    public AlertController: AlertController
  ) {}

  ionViewDidLoad() {
    // this.bucketList.push({
    //   'bucketKey': 'asdqwe',
    //   'policeKey': 'qwe',
    //   'createDate': 'asssss',
    //   'urns':['qwerrr']
    // });
    this.showBuckets();
    // this.rest.createBucket();
    // setTimeout( this.autoLoad.bind(this), 2000);
  }

  getBucketDetail(key) {
    this.rest.getBucketDetail(key)
    .subscribe(
      (res) => {
        let result = JSON.parse(JSON.stringify(res));
        // this.autoLoad();
      },
      (err) => {}
    );
  }

  loadUrn(urn, name, bucketKey) {
    let prevUrn = localStorage.getItem('urn');
    if(localStorage.getItem('jsonInput') != null) {
      let data = {
        jsonInput: JSON.parse(localStorage.getItem('jsonInput')),
        colorSaver: JSON.parse(localStorage.getItem('colorSaver')),
        indexList: JSON.parse(localStorage.getItem('indexList'))
      };
      localStorage.setItem(prevUrn, JSON.stringify(data));
    }
    
    console.log('prevUrn => ', prevUrn);
    console.log('urn => ', urn);
    if(localStorage.getItem(urn) != null) {
      console.log('tentsuu baina.');
      let nowData = JSON.parse(localStorage.getItem(urn));
      console.log('nowData => ',nowData);
      localStorage.setItem('jsonInput', JSON.stringify(nowData.jsonInput));
      localStorage.setItem('colorSaver', JSON.stringify(nowData.colorSaver));
      localStorage.setItem('indexList', JSON.stringify(nowData.indexList));
    } else {
      localStorage.setItem('jsonInput', JSON.stringify([]));
      localStorage.setItem('colorSaver', JSON.stringify({}));
      localStorage.setItem('indexList', JSON.stringify([]));
    }



    localStorage.setItem('urn', urn);
    localStorage.setItem('bucketKey', bucketKey);
    localStorage.setItem('outputFileNameOSS', name);
    localStorage.setItem('inputFileNameOSS', name);

    this.navCtrl.push(ViewerPage);
  }

  deleteBucket(key) {
    console.log('key is => ', key);
    this.presentLoadingWithOptions();
    this.rest.getBucketObjects(key)
    .subscribe((res3) => {
      let urns = res3.items;
      if(urns.length == 0) {
        this.rest.deleteBucket(key)
        .subscribe(
          (res) => {
            console.log(res);
            let suffix = key.split('_tutorial_bucket_susano')[1];
            this.rest.updatebucket(suffix,'','delete').subscribe( responseofupdate => {
              console.log('responseof update => ', responseofupdate);
              this.showBuckets();
            });
          });
      } else {
        for(let k = 0; k < res3.items.length; k++) {
          urns[k].objectId = btoa(urns[k].objectId);
          this.rest.deleteBucketObject(key, urns[k].objectKey)
          .subscribe(
            (res) => {
              console.log(res);
              this.rest.deleteUrn(urns[k].objectId).subscribe(urn => {  
                if(k == res3.items.length - 1) {                          
                  this.rest.deleteBucket(key)
                  .subscribe(
                    (res) => {
                      console.log(res);
                      this.bucketList = [];
                      this.rest.getBuckets()
                      .subscribe((res) => {
                        let result = JSON.parse(JSON.stringify(res)).items;
                        this.stopLoading();
                        if (result.length !== 0) {
                          this.presentLoadingWithOptions();
                          for (let i = 0; i < result.length; i++) {
                            let bucket = result[i];              
                            this.rest.getBucketObjects(bucket.bucketKey)
                            .subscribe((res3) => {
                              if(i == result.length - 1) {
                                this.stopLoading();
                              }
                              // console.log(res3);
                              let urns = res3.items;
                              for(let k = 0; k < res3.items.length; k++) {
                                urns[k].objectId = btoa(urns[k].objectId);
                              }
                              this.bucketList.push({
                                bucketKey: bucket.bucketKey,
                                policeKey: bucket.policeKey,
                                createdDate: bucket.createdDate,
                                urns: urns
                              });
                            });              
                          }
                        }
                      });
                    },
                    (err) => {
                      this.stopLoading();
                    }
                  );
                }
              });        
            },
            (err) => {
              this.stopLoading();
            }
          );
        }
      }
      if(res3.items.length == 0) {
        this.stopLoading();
      }
    });
  }

  async deleteBucketObject(urn, key, name, bucketId) {


    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      message: 'フォルダから完全に削除され、どこにも残りませんがよろしいでしょうか。',
      buttons: [
        {
          text: 'いいえ',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'はい',
          handler: () => {
            this.rest.deleteBucketObject(key, name)
            .subscribe(
              (res) => {
                console.log(res);
                this.rest.deleteUrn(urn).subscribe(urnResponse => {
                  this.rest.updateUserTime(localStorage.getItem('userId'), bucketId, atob(urn), 1, 'create').subscribe(userTimeResponse => {
                    this.showBuckets();
                  });
                });
              },
              (err) => {
                this.stopLoading();
              }
            );
          }
        }
      ]
    });

    await alert.present();
  }

  async onSubmit(bucketKey) {
    this.presentLoadingWithOptions();
    this.rest.getNickName().subscribe(res => {
      console.log("nickname is => ", res);
    });
    
    console.log('bucketKey => ',bucketKey)
    localStorage.setItem('inputFileNameOSS', this.fileToUpload.name);
    localStorage.setItem('outputFileNameOSS', this.fileToUpload.name);
    let fileSize = this.fileToUpload.size;
    let userId = localStorage.getItem('userId');
    
    if(fileSize >= 100*1024*1024) {
      
      let statusResponse;
      var chunkSize = 1024 * 1024 * 5;
      var startingByte = 0;
      var endingByte = startingByte + chunkSize - 1;
      var nbofChunks = Math.ceil(fileSize / chunkSize);
      let contentRange;
      let sessionId = new Date().getTime();
      for(let i = 0; i < nbofChunks; i++) {
        console.log(nbofChunks, i);
        if(nbofChunks == i + 1) {
          console.log('ene l unen bolj chadahgui baina daa');
          endingByte = fileSize - 1;
        }
        console.log('start->', startingByte, 'end->', endingByte, 'file size=> ', fileSize);
        contentRange = 'bytes ' + startingByte + '-' + endingByte + '/' + fileSize;
        statusResponse = await this.rest.uploadObjects(this.fileToUpload, this.fileContent, contentRange, startingByte, endingByte, sessionId, bucketKey).pipe(first()).toPromise();
        console.log('statusResponse => ', statusResponse);
        startingByte = endingByte + 1;
        endingByte = startingByte + chunkSize - 1;
        if(nbofChunks == i + 1) {
          let result = JSON.parse(JSON.stringify(statusResponse));
          var urn = btoa(result.objectId); // TODO 
          // localStorage.setItem("bucket-" + this.rest.getBucket(), urn);
          localStorage.setItem('urn', urn);
          this.rest.updateUserTime(userId, this.bucketId, result.objectId, 0, 'create').subscribe ( responseofUserTime => {
            console.log('hariu ni => ',responseofUserTime);
            if(responseofUserTime.result == 'ok') {
              console.log('responseofUserTime hariu ok baina.');
              this.rest.translateObject(urn).subscribe((res) => {
                this.stopLoading();
                // localStorage.setItem("bucket-" + this.rest.getBucket(), res.urn);
                // localStorage.setItem('urn', localStorage.getItem('bucket-' + this.rest.getBucket()));
                localStorage.setItem('urn', res.urn);
                this.navCtrl.push(ViewerPage, { urn: res.urn });
              });
            }
          });
        }
      }
    } else {
      this.rest.uploadObjects(this.fileToUpload, this.fileContent, null, null, null, null, bucketKey)
      .subscribe((res) => {
        console.log('uploadObjects => ',res);
        let result = JSON.parse(JSON.stringify(res));
        localStorage.setItem('sha1', result.sha1);
        var urn = btoa(result.objectId);
        localStorage.setItem('urn', urn);
        this.rest.updateUserTime(userId, this.bucketId, result.objectId, 0, 'create').subscribe ( responseofUserTime => {
          console.log('hariu ni => ',responseofUserTime);
          if(responseofUserTime.result == 'ok') {
            this.rest.translateObject(urn).subscribe((res) => {
              this.stopLoading();
              localStorage.setItem("bucketKey", bucketKey);
              localStorage.setItem("objectKey", res.urn);
              localStorage.setItem('urn', res.urn);
              this.navCtrl.push(ViewerPage, { urn: res.urn });
            });
          }
        });
      });
    }
  }

  async createBucket(){
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: 'フォルダ名を入力してください。',
      inputs: [
        {
          name: 'name2',
          type: 'text',
          id: 'bucketName',
          placeholder: 'Bucket name'
        }
      ],
      buttons: [
        {
          text: 'いいえ',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'はい',
          handler: () => {
            // this.arrayofId.push("3");
            console.log('array => ',this.arrayofId);
            let newBucketKey = this.arrayofId.length == 0 ? '0' : parseInt(this.arrayofId.reduce(function(a, b) {
              return Math.max(a, b);
            })) + 1;
            console.log('newBucket Key => ',newBucketKey);
            let name = $('#bucketName').val();
            this.rest.createBucket(newBucketKey).subscribe(bucket => {
              console.log(newBucketKey, name);
              this.rest.updatebucket(newBucketKey, name, 'create').subscribe( updateBucket => {
                console.log('final answer => ', updateBucket);
                this.showBuckets();
              });
            });
          }
        }
      ]
    });

    await alert.present();

  }

  async updateBucket(id,bucketName){
    console.log(bucketName);
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: 'フォルダ名を編集できます。',
      enableBackdropDismiss: true,
      inputs: [
        {
          name: 'name2',
          type: 'text',
          id: 'bucketName',
          value: bucketName,
          placeholder: 'Bucket name'
        }
      ],
      buttons: [
        {
          text: 'いいえ',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'はい',
          handler: () => {
            console.log(id, $('#bucketName').val());
            this.rest.updatebucket(id, $('#bucketName').val(), 'update').subscribe( updateBucket => {
              console.log('final answer => ', updateBucket);
              this.showBuckets();
            });
          }
        }
      ]
    });

    await alert.present();

  }

  handleFileInput(files: FileList) {
    var i = $(this).prev('label').clone();

    if(files.length > 0) {
      this.reader.readAsBinaryString(files.item(0));

      this.reader.onload = (res) => {
        this.fileContent = this.reader.result.toString();
        this.fileToUpload = files.item(0);
        this.checkFile = true;
        if(typeof files[0].name != 'undefined'){
          // $('#uploadButton').text(files[0].name);
          this.onSubmit(this.bucketKey);
        }
      };
    }
  }

  async presentLoadingWithOptions() {
    this.loading = await this.loadingController.create({
      spinner: null,
      content: 'お待ちください...',
      cssClass: 'custom-class custom-loading'
    });
    return await this.loading.present();
  }
  
  async stopLoading() {
    return await this.loading.dismiss();
  }

  autoLoad() {
    let blob = new Blob([new Uint8Array(this.reader.result as ArrayBuffer)]);
    var file = new File([blob], "rst_basic_sample_project.rvt");
    this.fileContent = Buffer.from('d0c100');
    this.fileToUpload = file;
    this.onSubmit(this.bucketKey);
  }

  async presentAlertConfirm(key) {
    
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: '警告!',
      message: '<p><strong>バケット</strong>を削除してもよろしいですか</p>',
      buttons: [
        {
          text: 'キャンセル',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log("cancelled");
          }
        }, {
          text: 'はい',
          handler: () => {
            this.deleteBucket(key);
          }
        }
      ]
    });

    await alert.present();
  }
  async presentAlertUploadBucket(key,bucketId) {

    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      message: '<p>※データアップには、変換作業処理も実行されるので時間がかかります。</p><p>また、実行するにはAutodeskクラウドクレジットの費用が発生しますので、むやみなアップロードは避けてください。</p><p>費用は、Highbig管理者にて管理しています。</p>',
      buttons: [
        {
          text: 'キャンセル',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log("cancelled");
          }
        }, {
          text: '今すぐ実行',
          handler: () => {
            this.bucketKey = key;
            this.bucketId = bucketId;
            console.log('works fine => ', document.getElementById("files"));
            document.getElementById("files").click();
          }
        }
      ]
    });

    await alert.present();

  }
  async presentAlertEngine() {
    let request_sent = this.modalController.create(
      ModalsEngineselectorPage,
      {},
      {
        showBackdrop: true,
        enableBackdropDismiss: true,
      }
    );

    request_sent.present().catch(err => {

    });
  }

  showBuckets() {
    this.bucketList = [];
    this.presentLoadingWithOptions();
    this.rest.getAccessToken('upload').subscribe(res1 => {
      let result = JSON.parse(JSON.stringify(res1));
      if (result.access_token !== "") {
        localStorage.setItem("accessToken", result.access_token);
        this.rest.setAccessTokenNow(result.access_token);
        this.rest.buckets().subscribe( ourbuckets => {
          this.rest.getBuckets().subscribe((res) => {
            let forgebuckets = JSON.parse(JSON.stringify(res)).items;
            this.stopLoading();
            if (forgebuckets.length !== 0) {
              this.presentLoadingWithOptions();

              let actbucket:any = localStorage.getItem('activebucket');
              console.log('actBucket => ', actbucket);

              for (let i = 0; i < forgebuckets.length; i++) {
                let forgebucket = forgebuckets[i];
                this.rest.getBucketObjects(forgebucket.bucketKey)
                .subscribe((res3) => {
                    if(ourbuckets.result == 'ok'){
                      console.log('Manai list => ',ourbuckets);
                      console.log('Forge list => ',forgebuckets);
                      if(i == forgebuckets.length - 1) {
                        this.stopLoading();
                      }
                      let urns = res3.items;
                      for(let k = 0; k < res3.items.length; k++) {
                        this.rest.getUserTime(urns[k].objectId, 0).subscribe( responseUserTime => {
                          if(responseUserTime.data.length != 0) {
                            console.log('hariu ni bol => ', responseUserTime);
                            urns[k]['user'] = responseUserTime.data[0]['name'];
                            urns[k]['time'] = responseUserTime.data[0]['ontime'];
                            console.log(urns[k]['userTime']);
                          }
                        }, err => {
                          urns[k]['userTime'] = '';
                        });
                        urns[k].objectId = btoa(urns[k].objectId);
                        
                        console.log("#########################################");
                        console.log(this.bucketList);
                        console.log("#########################################");
                      }
                      for(let j = 0; j < ourbuckets.data.length; j++) {
                        if(ourbuckets.data[j].bucket_id == forgebucket.bucketKey) { // == bucket.bucketKey TODO
                          console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$');
                          if(localStorage.getItem('role') == '1' || localStorage.getItem('role') == '4') {
                            this.bucketList.push({
                              bucketKey: forgebucket.bucketKey,
                              policeKey: forgebucket.policeKey,
                              createdDate: forgebucket.createdDate,
                              urns: urns,
                              bucketName: ourbuckets.data[j].bucket_name,
                              dbBucketId: ourbuckets.data[j].id
                            });
                            this.arrayofId.push(ourbuckets.data[j].id);
                            console.log('bucketList else else => ',this.bucketList);
                          } else {
                            if(actbucket != null) {
                              if(actbucket.includes(',')) {
                                let bucketIdarray = actbucket.split(',');
                                console.log('bucketIdArray', bucketIdarray);
                                for(let k = 0; k < bucketIdarray.length; k++) {
                                  if(bucketIdarray[k] != null) {
                                    console.log('bucket array JJJ => ', bucketIdarray[k]);
                                    if(bucketIdarray[k] == ourbuckets.data[j].id) {
                                      this.bucketList.push({
                                        bucketKey: forgebucket.bucketKey,
                                        policeKey: forgebucket.policeKey,
                                        createdDate: forgebucket.createdDate,
                                        urns: urns,
                                        bucketName: ourbuckets.data[j].bucket_name,
                                        dbBucketId: ourbuckets.data[j].id
                                      });
                                      this.arrayofId.push(ourbuckets.data[j].id);
                                      console.log('bucketList => ',this.bucketList);
                                    }
                                  }
                                }
                              } else {
                                if(actbucket == ourbuckets.data[j].id) {
                                  this.bucketList.push({
                                    bucketKey: forgebucket.bucketKey,
                                    policeKey: forgebucket.policeKey,
                                    createdDate: forgebucket.createdDate,
                                    urns: urns,
                                    bucketName: ourbuckets.data[j].bucket_name,
                                    dbBucketId: ourbuckets.data[j].id
                                  });
                                  this.arrayofId.push(ourbuckets.data[j].id);
                                  console.log('bucketList else => ',this.bucketList);
                                }
                              }
                            }
                          }
                        }
                      }
                    } 
                  });              
                }
              }
            });
        });
      }
    });
  }

  async download(bucketKey, objectKey) {
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: '警告!',
      message: 'ダウンロード実行しますか。データ容量により時間がかかります。',
      buttons: [
        {
          text: 'はい',
          handler: () => {
            this.rest.getDefinedActivities(1).subscribe(activities => {
              activities.data.forEach(element => {
                if(element.split('.')[1].split('+')[0].includes(this.activity_name)) {
                  this.activityList.push(element);
                }
              }); // TODO doorhi code iin bichigleliig ynzalna.
              if(this.activityList[1] != null) {
                this.rest.deleteActivity(this.activityList[1].split('.')[1].split('+')[0]).subscribe( response => {
                  this.aliasWorkItem(bucketKey,objectKey);
                });
              } else {
                this.aliasWorkItem(bucketKey,objectKey);
              }
              // this.stopLoading();
            });
          }
        }, {
          text: 'いいえ',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log("cancelled");
          }
        }
      ]
    });

    await alert.present();
  }

  aliasWorkItem(bucketKey,objectKey) {
    let alias = '23';
    this.presentLoadingWithOptions();
    let qualifiedAppBundleId = FORGECLIENT.CLIENT_ID + '.' + this.activity_name + '+' + alias;
    let enginename = localStorage.getItem('engine') == null ? 'Autodesk.Revit+2020' : localStorage.getItem('engine');
    this.rest.createActivity(enginename,this.activity_name,qualifiedAppBundleId,this.activity_name).subscribe(active => {
      if (active == null) {
        console.log("Api amjiltgui hariu irlee");
      } else {
        // this.getAllActivities();
        this.rest.createActivityAlias(this.activity_name, alias).subscribe(async alias => {
          if(alias == null) {
            console.log("Api amjiltgui hariu irlee");
          } else {
            // 7.CREATE WORKITEM
            let param = {};
            param['bucketKey'] = bucketKey;
            param['inputFileNameOSS'] = objectKey;
            param['jsonInput'] = {};
            param['jsonInput']['array'] = JSON.stringify([]); //jsonInput.slice(begin,end) || jsonPayload
            this.rest.createWorkItem(qualifiedAppBundleId, param).subscribe(async work => {
              if(work == null) {
                console.log("Api amjiltgui hariu irlee");
              } else {
                let workItemId = work['id'];
                let ossOutputUrl = work['ossOutputUrl'];
                let outputFileNameOSS = work['outputFileNameOSS'];
                // 8.CHECK WORKITEM STATUS AND DOWNLOAD RESULT/REPORT
                let status = 'pending';
                console.log('---work item running!');
                let start_time = new Date().getTime();
                let check = true;
                while(check) {
                  const statusResponse = await this.rest.getWorkItemStatus(workItemId).pipe(first()).toPromise();
                    if(statusResponse == null) {
                      console.log("Api amjiltgui hariu irlee");
                    }
                    status = statusResponse['status'];
                    if(status != 'pending' && status != 'inprogress') {
                      check = false;
                      // 9.GET OUTPUT FILE OR LOG FILE     
                      if(status == 'success') {
                        this.http
                          .get(localStorage.getItem('ossOutputUrl'), {headers: {'Authorization': 'Bearer ' + this.rest.getAccessTokenNow()}, responseType: 'blob'}).subscribe(response => {
                            
                            var a = document.createElement("a");

                            document.body.appendChild(a);
                            // a.style = "display: none";
                            // var json = JSON.stringify(response);
                            // var blob = new Blob([json], {type: "octet/stream"});

                            let url = window.URL.createObjectURL(response);
                            a.href = url;
                            let dateObj = new Date();
                            let year = dateObj.getFullYear();
                            let month = dateObj.getMonth() + 1;
                            let day = dateObj.getDate();
                            let hour = dateObj.getHours();
                            let minute = dateObj.getMinutes();

                            a.download = objectKey.split('.')[0] + '_' + year + '-' + month + '-' + day + '_' + hour + ':' + minute + '.' + objectKey.split('.')[1];
                            a.click();
                            window.URL.revokeObjectURL(url);
                            this.stopLoading();
                          });
                      } else {
                        this.stopLoading();
                        console.log('---downloading report file: ' + workItemId + '.log');
                        let reportUrl = statusResponse['reportUrl'];
                        let response = this.http
                          .get(reportUrl);
                          // this.file.writeFile('C:\Users\User\Desktop', 'log', response['content'], {replace: true, append: false})
                          console.log('get log file succeeded: ' + response['content']);
                      }
                    }
                    let elapsed_time = new Date().getTime() - start_time;
                    if(elapsed_time > 600) {
                      console.log('     get work item status timeout!');
                    }                              
                }
              }
                  
                  // this.stopLoading();
                  // console.log('****work item status: ', status);
                
            });
          }
        });
      }
    });
  }
  falseValue(){
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/pages/upload/upload.ts